// @ts-nocheck
export const localeCodes =  []
export const localeLoaders = {}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/db048695" /* webpackChunkName: "config_i18n_46config_46ts_db048695" */)
]
export const normalizedLocales = []
/** client **/

/** client-end **/